import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions, { humanReadable } from '../../../../utils/useWindowDimensions';

const TimeSpentLearning = ({ chartLabels }) => {
    const { width } = useWindowDimensions();
    const [chartData, setChartData] = useState({
        series: [
            { name: 'Learning', data: [] },
        ],
        options: {
            chart: {
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0,
                        },
                    },
                },
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
            xaxis: {
                categories: [], // Static categories
            },
            yaxis: {
                labels: {
                    show: true,
                    formatter: (value) => humanReadable(value),
                }
            },
            legend: {
                show: false, // Hide the legend
            },
            fill: {
                opacity: 1,
            },
            colors: ["#3e4095"],
        }
    });

    useEffect(()=>{

        let chartBarName = [];
        let value = [];
         chartLabels.map((e, i) => {
                chartBarName.push(e.label);
                value.push(e.counts.all.sum.inSeconds);
            });

          setChartData({
            series: [
                { name: 'Learning', data: value },
               ],
                dataLabels: {
                    enabled: false,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                options: {
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        toolbar: {
                            show: true,
                        },
                        zoom: {
                            enabled: true,
                        },
                    },
                    dataLabels: {
                      enabled: false
                  },
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                legend: {
                                    position: 'bottom',
                                    offsetX: -10,
                                    offsetY: 0,
                                },
                            },
                        },
                    ],
                    plotOptions: {
                        bar: {
                          horizontal: false,
                          dataLabels: {
                            enabled: false, // Set this to false to hide the numbers at the top and middle of the bars
                          },
                        },
                      },
                    xaxis: {
                        categories: chartBarName,
                    },
                    yaxis: {
                        labels: {
                            show: false,
                            formatter: (value , index) => {
                                return humanReadable(value);
                            }
                        }
                    },
                    legend: {
                        show: false, // Set this to false to hide the legend
                      },
                    fill: {
                        opacity: 1,
                    },
                    colors: ["#3e4095"],
                }
            });

        
        
    },[chartLabels])

    return (
        <div id="chart">
            <ReactApexChart options={chartData.options} series={chartData.series} type="bar"  height={width > 1500 ? 250 : 198} />
        </div>
    );
}

export default TimeSpentLearning;
